export default "__VITE_ASSET__fgaSE7wR__"